import React from 'react';
import { Panel } from 'react-bootstrap';
import PagedEntitiesList from '../../../common/components/PagedEntitiesList';
import { withTranslation } from 'react-i18next';
import ui from '../../../common/services/ui';

const Summary = ({ t, ...rest }) => {
	const columns = [
		{
			header: t('CampaignStats_CampaignName'),
			accessor: 'campaignName',
			sortable: true
		},
		{
			header: t('CampaignStats_CampaignMedium'),
			accessor: 'campaignMedium',
			sortable: true
		},
		{
			header: t('CampaignStats_CampaignSource'),
			accessor: 'campaignSource',
			sortable: true
		},
		{
			header: t('CampaignStats_SalesCount'),
			accessor: 'salesCount',
			cell: (salesCount) => ui.formatAmount(salesCount),
			sortable: true
		},
		{
			header: t('CampaignStats_SalesTotal'),
			accessor: 'salesTotal',
			sortable: true
		},
		{
			header: t('CampaignStats_SalesOutstandingTotal'),
			accessor: 'salesOutstandingTotal',
			sortable: true
		},
		{
			header: t('CampaignStats_SalesDiscount'),
			accessor: 'salesDiscount',
			sortable: true
		}		
	];

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(Summary);